import { Box, ButtonNew, Icon, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import { Switch } from 'react-native'
import { TableComponent } from '../../../comps/TableComponent'
import { AddWebHookView } from './AddWebHookView'

interface AddOrEditWebhookDialogProps {
  showWebHookDialog: any
  setShowWebHookDialog: any
  mode: 'add' | 'view'
}

const data = [
  {
    title: 'Webhook URL',
    description: 'https://login.jioconnect.com/oaam_server/loginPage.jsp',
  },
  {
    title: 'Status',
    type: 'switch',
    isActive: true,
  },
  {
    title: 'Active Event',
    description: '1 Active Event',
    subDescription: 'Payment Event - Intent',
  },
  {
    title: 'Alert Email',
    description: 'test@ril.com',
    subDescription: 'Receive email alert for webhook faliure',
  },
]
//const data = ['hdj']

const renderItem = ({ item }: any) => {
  return (
    <Box flexDirection="row" pv={15}>
      <Box minWidth={180}>
        <Text color="DARK_GREY" fontSize={14} fontWeight="BOLD">
          {item.title}
        </Text>
      </Box>
      <Box>
        <Text color="BLACK" fontSize={14} fontWeight="500">
          {item.description}
        </Text>
        <Spacer size={10} />
        <Text color="DARK_GREY" fontSize={14} fontWeight="500">
          {item.subDescription}
        </Text>
        {item.type === 'switch' && (
          <Box flexDirection="row">
            <Switch
              style={{ transform: [{ scaleX: 0.6 }, { scaleY: 0.6 }] }}
              trackColor={{ false: '#1386B080', true: '#1386B080' }}
              thumbColor={'#1386B0'}
              value={item.isActive}
            />
            <Text color={'PRIMARY'}>Active</Text>
          </Box>
        )}
      </Box>
    </Box>
  )
}
const AddOrEditWebhookDialog = ({
  showWebHookDialog,
  setShowWebHookDialog,
  mode = 'add',
}: AddOrEditWebhookDialogProps) => {
  return (
    <ModalDialog
      children={
        <Box backgroundColor={'WHITE'} height={'100vh'} width={650}>
          <Box flexDirection="row" pv={18} ph={30} alignItems="center" justifyContent="space-between">
            <Text fontSize={20} fontWeight="FONT_WEIGHT_BOLD" color="BLACK_21">
              {mode === 'add' ? 'Add New Webhook URL' : 'Webhook Details'}
            </Text>
            <Box flexDirection="row" alignItems="center">
              {mode === 'view' && (
                <ButtonNew
                  title="Edit"
                  type="secondaryIconSmall"
                  onPress={() => {}}
                  icon="EDIT"
                  borderColor="LIGHT_GREY"
                  borderRadius={4}
                  titleColor="BLACK_21"
                />
              )}
              {mode === 'add' && <ButtonNew title="Save" type="primarySmall" onPress={() => {}} borderRadius={4} />}
              <Spacer size={16} direction="horizontal" />
              <Icon id="CLOSE" size={24} color="BLACK_21" />
            </Box>
          </Box>
          <Box height={1} backgroundColor="GRAY_BORDER" />
          <Box pv={18} ph={30}>
            {mode === 'view' && (
              <TableComponent
                value={''} //Routes value
                canFetchMore={false}
                hide={false}
                isCustom={true}
                ListContent={data}
                RenderCustomElement={renderItem}
                //keyExtractor={keyExtractor}
              />
            )}
            {mode === 'add' && <AddWebHookView />}
          </Box>
        </Box>
      }
      show={showWebHookDialog}
      type={'Right'}
      onDismiss={() => setShowWebHookDialog(!showWebHookDialog)}
    />
  )
}

export { AddOrEditWebhookDialog }
